import { Modal, Button } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import {
  deleteTemplateContextAction,
  listTemplateContextsAction,
} from '../../../../store/actions/templatecontext.action';

type DeleteTemplateContextProps = {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  templateContextId: string | null;
  filters?: Record<string, string>;
};

const DeleteTemplateContext = ({
  isOpen,
  setIsOpen,
  templateContextId,
  filters,
}: DeleteTemplateContextProps) => {
  const dispatch = useDispatch() as (action: unknown) => unknown;

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleDelete = () => {
    if (!templateContextId) return;

    dispatch(
      deleteTemplateContextAction(templateContextId, () => {
        handleClose();
        dispatch(listTemplateContextsAction(filters));
      })
    );
  };

  return (
    <Modal
      title="Delete Template Context"
      open={isOpen}
      onCancel={handleClose}
      footer={null}
      width={400}
    >
      <div className="flex flex-col items-center py-4">
        <ExclamationCircleOutlined
          style={{ fontSize: '48px', color: '#ff4d4f', marginBottom: '16px' }}
        />
        <h3 className="text-lg font-medium mb-2">Confirm Deletion</h3>
        <p className="text-center mb-6">
          Are you sure you want to delete this template context? This action
          cannot be undone.
        </p>
        <div className="flex justify-end w-full">
          <Button onClick={handleClose} className="mr-2">
            Cancel
          </Button>
          <Button type="primary" danger onClick={handleDelete}>
            Delete
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteTemplateContext;
